import React, {FunctionComponent, useEffect, useState} from 'react'
import {GridMain as Main} from './style'
import {IProps} from './IProps'

export const GridMain: FunctionComponent<IProps> = (props) => {
    const [displayColorGuide, setDisplayColorGuide] = useState<boolean>(false)

    useEffect(
        () => {
            setDisplayColorGuide(props.colorGuide)
        },
        []
    )

    return(
        <Main colorGuide={displayColorGuide}>
            {props.children}
        </Main>
    )
}
